import { render, staticRenderFns } from "./phoneManage.vue?vue&type=template&id=bc7a7e32&scoped=true"
import script from "./phoneManage.vue?vue&type=script&lang=js"
export * from "./phoneManage.vue?vue&type=script&lang=js"
import style0 from "./phoneManage.vue?vue&type=style&index=0&id=bc7a7e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7a7e32",
  null
  
)

export default component.exports